import React, { useContext, useEffect, useState } from "react";
import { MainContext } from "../../../../MainContext";
import { request } from "../../../../request";
import Swal from "sweetalert2";
import { Box, CircularProgress } from "@mui/material";
import { modifyTransaction } from "../_functions/modifyTransaction";
import DatePickerInput from "./DatePicker/DatePickerInput";
import { convertToApproximateString } from "../../Inputs/convert";
import { Transaction as TransactionComponent } from "./Transaction/Transaction";

interface Transaction {
    _id: string;
    id: string;
    timeStamp: string;
    date?: string;
    joined_transaction_id: string;
    comment?: string;
    signature?: string;
    toBeBounded?: boolean;
}

interface Profit {
    hrach?: number;
    artyom?: number;
    fahad?: number;
}

interface JoinedTransaction {
    _id: string;
    transactions: Transaction[];
    profits?: Profit;
    finished?: boolean;
}

export const TransactionListPrev: React.FC<any> = ({ fake, setFake, transactions: myTransactions, date, getFilteredHistory }) => {
    const { darkMode, customers, accounts, inactiveAccounts, transactions, updateTransactions, users, updateAccounts, updateCapital } = useContext(MainContext);

    const [joinedTransactions, setJoinedTransactions] = useState<JoinedTransaction[]>([]);

    const returnTransaction = async (trans: any, hideAlert?: boolean) => {
        const id = trans.id;
        const joined_transaction_id = trans.joined_transaction_id;
        try {
            const newTransaction: any = {
                from: trans.from,
                to: trans.to,
                labels: myTransactions.find((t: any) => t._id.toString() === trans.id.toString()).labels,
                toBeBounded: trans.toBeBounded,
                comment: trans.comment,
                finished: trans.finished,
                timeStamp: trans.timeStamp,
            };
            if (joined_transaction_id) {
                newTransaction.joined_transaction_id = joined_transaction_id;
            }
            // await new Promise((rs, rj) => setTimeout(rs, 2500));
            await request.post("/transaction/", newTransaction);
            //@ts-ignore
            console.log(JSON.parse(window.localStorage.getItem("returnables")));
            console.log(id);
            //@ts-ignore
            const returnables = JSON.parse(window.localStorage.getItem("returnables")).filter((t) => t.id !== id && t._id !== id);
            console.log(returnables);
            window.localStorage.setItem("returnables", JSON.stringify(returnables));
            if (!hideAlert) {
                Swal.fire({ title: "Transaction added successfully", icon: "success" });
                updateAccounts();
                updateTransactions();
                updateCapital();
                getFilteredHistory();
            } else {
                setFake(!fake);
            }
            return true;
        } catch (error) {
            console.error(error);
            if (hideAlert) {
                throw new Error("");
            }
            return false;
        }
    };

    const returnMultipleTransaction = async (transactions: any[]) => {
        console.log(transactions);
        try {
            const total = transactions.length;
            let completed = 0;

            // Show initial Swal
            Swal.fire({
                title: "Processing...",
                html: `0 / ${total} completed`,
                allowOutsideClick: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                },
            });

            for (const trans of transactions) {
                // simulate your function (replace with your real one)
                await returnTransaction(trans, true);

                completed++;

                // Update swal content dynamically
                Swal.update({
                    html: `${completed} / ${total} completed`,
                });
            }

            // When done
            Swal.fire({
                icon: "success",
                title: "Done!",
                text: `${total} tasks completed successfully`,
            });
            await request.get(`/transaction/reset-deleter`);
            updateAccounts();
            updateTransactions();
            updateCapital();
            getFilteredHistory();
        } catch (error) {
            console.error(error);
        }
    };

    const deleteTransaction = (id: string) => {
        Swal.fire({
            title: "HEY!",
            text: "You are about to delete the transaction permanently. Are you sure?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes",
            showLoaderOnConfirm: true,
            preConfirm: async () => {
                //@ts-ignore
                const returnables = JSON.parse(window.localStorage.getItem("returnables")).filter((t: any) => t.id !== id && t._id !== id);
                console.log(returnables);
                window.localStorage.setItem("returnables", JSON.stringify(returnables));
                updateTransactions();
                if (returnables.length === 0) {
                    await request.get(`/transaction/reset-deleter`);
                }
            },
        });
    };

    useEffect(() => {
        const joinedTransactionsRaw = Array.from(new Set(myTransactions.map((t: any) => t.joined_transaction_id?.toString()))).map((id) => ({ _id: id }));
        if (joinedTransactionsRaw?.length && transactions?.length) {
            const newJoinedTransactions = joinedTransactionsRaw.map((joinedTransaction: any) => {
                let neededTransactions = myTransactions.filter((t: any) => t.joined_transaction_id === joinedTransaction._id).map((t: any) => modifyTransaction(t, [...customers, ...accounts, ...inactiveAccounts]));

                if (myTransactions.length === 0) {
                    neededTransactions = transactions.filter((t: Transaction) => t.joined_transaction_id === joinedTransaction._id).map((t: Transaction) => modifyTransaction(t, [...customers, ...accounts, ...inactiveAccounts]));
                }

                return {
                    ...joinedTransaction,
                    transactions: neededTransactions,
                };
            });

            setJoinedTransactions(
                newJoinedTransactions
                    .filter((jt: any) => jt.transactions.length)
                    .sort((a: any, b: any) => {
                        const dateToUse = date ?? new Date(Date.now() - 24 * 60 * 60 * 1000);
                        const t1 = b.transactions.find((t: any) => new Date(t.timeStamp).getTime() > dateToUse.getTime() && new Date(t.timeStamp).getTime() < dateToUse.getTime() + 24 * 60 * 60 * 1000);
                        const t2 = a.transactions.find((t: any) => new Date(t.timeStamp).getTime() > dateToUse.getTime() && new Date(t.timeStamp).getTime() < dateToUse.getTime() + 24 * 60 * 60 * 1000);
                        return new Date(t1?.timeStamp || 0).getTime() - new Date(t2?.timeStamp || 0).getTime();
                    })
            );
        } else {
            setJoinedTransactions([]);
        }
    }, [myTransactions]);

    const changeFinishedBound = async (id: string) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "You are about to change finished status of bounded transaction",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes",
        });

        if (result.isConfirmed) {
            await request.post(`/transaction/change-finished-bound/${id}`);
            updateTransactions();
        }
    };

    return (
        <div className={"transactionList"}>
            <div className={"content"}>
                <div className={"transactions"} style={{ backgroundColor: "#333" }}>
                    {joinedTransactions.map((joinedTransaction, i) => {
                        const signature = joinedTransaction.transactions.map((t) => users.find((u: any) => u._id.toString() === t.signature?.toString())?.login).join(" - ");

                        return (
                            joinedTransaction.transactions.length > 0 && (
                                <div key={joinedTransaction._id} className={"joinedTransaction"}>
                                    <div className={"topper"}>
                                        {!joinedTransaction.transactions[0]?.toBeBounded || joinedTransaction.transactions.length <= 1 ? (
                                            <p className={"topperText"}>
                                                {joinedTransaction.transactions[0]?.date} - {signature} - kurs
                                            </p>
                                        ) : (
                                            <p className={"topperText"}>{signature}</p>
                                        )}

                                        <p className={"topperText"}>
                                            {joinedTransaction.transactions
                                                .map((t) => t.comment)
                                                .filter(Boolean)
                                                .join(", ")}
                                        </p>

                                        {joinedTransaction.profits && (
                                            <>
                                                {Math.abs(joinedTransaction.profits.hrach ?? 0) > 1 && <p className={"topperText"}>H: {convertToApproximateString(joinedTransaction.profits.hrach!)} AMD</p>}
                                                {Math.abs(joinedTransaction.profits.artyom ?? 0) > 1 && <p className={"topperText"}>A: {convertToApproximateString(joinedTransaction.profits.artyom!)} AMD</p>}
                                                {Math.abs(joinedTransaction.profits.fahad ?? 0) > 1 && <p className={"topperText"}>F: {convertToApproximateString(joinedTransaction.profits.fahad!)} AMD</p>}
                                            </>
                                        )}
                                        {i !== joinedTransactions.length - 1 && (
                                            <button
                                                className={"backButton"}
                                                onClick={() => {
                                                    returnMultipleTransaction(
                                                        joinedTransactions
                                                            .map((e) => e.transactions)
                                                            .slice(i, 999999)
                                                            .flat(2)
                                                            .sort((a, b) => new Date(a.timeStamp).getTime() - new Date(b.timeStamp).getTime())
                                                    );
                                                }}
                                            >
                                                Bring back {i === 0 ? "all" : "from here"} ↓
                                            </button>
                                        )}

                                        <button
                                            className={"backButton"}
                                            onClick={() => {
                                                const trans: any = joinedTransaction.transactions[0];
                                                returnTransaction(trans);
                                            }}
                                        >
                                            ↓
                                        </button>
                                        <button
                                            className={"backButton"}
                                            onClick={() => {
                                                const trans: any = joinedTransaction.transactions[0];
                                                deleteTransaction(trans.id);
                                            }}
                                        >
                                            X
                                        </button>
                                    </div>

                                    <div className={"transactionCopmonents"}>
                                        {joinedTransaction.transactions.reverse().map((transaction, indexik, arr) => (
                                            <TransactionComponent key={transaction.id} transaction={transaction} arr={arr} indexik={indexik} joined_transaction={joinedTransaction} getFilteredHistory={getFilteredHistory} />
                                        ))}
                                    </div>

                                    {joinedTransaction.finished !== undefined && (
                                        <>
                                            <hr />
                                            <label className={"checkboxLabel"}>
                                                <p className={"checkboxText"}>Finished: </p>
                                                <input type="checkbox" hidden onChange={() => changeFinishedBound(joinedTransaction._id)} />
                                                <span className={joinedTransaction.finished ? "checked" : "unchecked"}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" className={"checkIcon"} viewBox="0 0 20 20" fill="currentColor">
                                                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 00-1.414 0L9 11.586 6.707 9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l7-7a1 1 0 000-1.414z" clipRule="evenodd" />
                                                    </svg>
                                                </span>
                                            </label>
                                        </>
                                    )}
                                </div>
                            )
                        );
                    })}
                </div>
            </div>
        </div>
    );
};
